<template>
  <Modal ref="modal" title="Aulas Práticas por Período" @cancel="close">
    <form class="export-container" @submit.prevent="handleSubmit">
      <Select :options="schemaOptions" legend="Auto escola" placeholder="Selecione uma auto escola" :modelValue="schema"
        @update:modelValue="$event => (schema = $event)" class="input-full" :disabled="loading" />

      <Select class="input-full" :options="instrutores" legend="Intrutor(a)"
        :placeholder="!instrutores.length ? 'Selecione uma auto escola' : 'Selecione um instrutor'"
        :modelValue="instrutor" @update:modelValue="$event => (instrutor = $event)" :disabled="loading || !schema" />

      <Select :options="categorias" legend="Categoria" placeholder="Selecione uma categoria" :modelValue="categoria"
        @update:modelValue="$event => (categoria = $event)" class="input-full" :disabled="loading" />

      <Period legend="Insira o período" :firstModelValue="initialDate" :secondModelValue="finalDate"
        @update:firstModelValue="$event => (initialDate = $event)"
        @update:secondModelValue="$event => (finalDate = $event)" :disabled="loading" />

      <Button type="submit" text="Fazer download" color="primary" :disabled="loading">
        <TrayArrowDown :size="18" />
      </Button>
    </form>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import Select from 'core/Select'
import Period from 'core/Period'
import Button from 'core/Button'
import TrayArrowDown from 'icons/TrayArrowDown'
import _export from '../../../../services/export'

export default {
  name: 'PorPeriodoModal',
  components: {
    Modal,
    Select,
    Period,
    Button,
    TrayArrowDown,
  },
  data() {
    return {
      role: Number(localStorage.id_role),
      schema: null,
      instrutor: null,
      categoria: null,
      initialDate: '',
      finalDate: '',
      schemaOptions: [],
      instrutores: [],
      categorias: [
        { value: 'ACC', text: 'ACC' },
        { value: 'A', text: 'A' },
        { value: 'B', text: 'B' },
        { value: 'C', text: 'C' },
        { value: 'D', text: 'D' },
        { value: 'E', text: 'E' },
        { value: 'AB', text: 'AB' },
        { value: 'AC', text: 'AC' },
        { value: 'AD', text: 'AD' },
        { value: 'AE', text: 'AE' },
      ],
      loading: false,
    }
  },
  async created() {
    if ([2, 6, 8].includes(this.role)) {
      await this.fetchCfcs()
    } else {
      await Promise.all([
        this.fetchInstrutores(),
      ])
    }
  },
  methods: {
    async open() {
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()

      this.initialDate = ''
      this.finalDate = ''
      this.loading = false
    },
    async fetchCfcs() {
      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/autoescola/todas`)
        .then((res) => {
          this.schemaOptions = res.body.dados.map(cfc => ({ value: cfc.tenant_schema, text: cfc.nome_fantasia }))
        })
        .catch((error) => {
          this.$toasted.show('Erro!' + error.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    async fetchInstrutores(schema) {
      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/instrutor/fetch${schema ? `?schema=${schema}` : ''}`)
        .then(res => {
          this.instrutores = res.body.dados.map(instrutor => ({ value: instrutor.id_instrutor, text: instrutor.nome }))
        })
        .catch(err => {
          this.$toasted.show('Erro ao buscar instrutores.', {
            position: 'top-right',
          })
        })
    },
    async handleSubmit() {
      if (!this.validateInputs()) {
        return
      }

      this.loading = true

      const params = {
        dataInicial: this.initialDate,
        dataFinal: this.finalDate,
      }

      if (this.schema) params.schema = this.schema
      if (this.instrutor) params.instrutor = this.instrutor
      if (this.categoria) params.categoria = this.categoria

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/export/planilha/aulas/praticas/periodo`, {
        params,
      })
        .then((res) => {
          _export.downloadCSV(res.body.dados, 'praticas-por-periodo')
        })
        .catch((err) => {
          this.$toasted.show(`Erro ao tentar gerar relatório: ${err.body.mensagem}`, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    validateInputs() {
      if (!this.initialDate || !this.finalDate) {
        this.$toasted.show('Os campos de período são obrigatórios.', {
          icon: 'fa-times',
          position: 'top-right',
        })
        return false
      }

      const initial = new Date(this.initialDate)
      const final = new Date(this.finalDate)

      if (final < initial) {
        this.$toasted.show('A data final deve ser menor que a data inicial!', {
          icon: 'fa-times',
          position: 'top-right',
        })
        return false
      }

      return true
    },
  },
  watch: {
    async schema(current, old) {
      this.instrutor = null
      this.categoria = null
      this.initialDate = ''
      this.finalDate = ''

      if (current) {
        await Promise.all([
          this.fetchInstrutores(current),
        ])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.loading {
  width: 40vw;
  display: flex;
  justify-content: center;
  align-items: center;
}

.export-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .format-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    span {
      font-size: 1rem;
      font-weight: 600;
      line-height: 21.82px;
      color: #606264;
    }
  }

  button {
    justify-content: center;
  }
}
</style>